import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Text from 'components/common/Text/Text'
import Columns from 'components/common/Columns/Columns'
import Link from 'components/common/Link/Link'
import Product from './components/Product'
import { MAP, TITLES } from './constants'

const RecommendedProducts = ({
  searchByVehicleUrl,
  gBBDetails,
  matchedSkusCount,
  activeVehicle: {
    vehicleName
  } = {}
}) =>
  <Wrapper>
    <Title headline centered>Best Matches for your { vehicleName } </Title>
    <Column width="33% 33% 33%" adaptive>
      {
        MAP.map((key, index) =>
          !gBBDetails[key] ?
            <div /> :
            <Product
              { ...gBBDetails[key] }
              index={ index }
              title={ TITLES[index] }
              imagePath={ gBBDetails[key].imagePath }
              brandLogoUrl={ gBBDetails[key].brandLogoUrl }
              details={ gBBDetails[key] }
              setOfFourPrice={ gBBDetails[key].setOfFourPrice }
              productDisplayName={ gBBDetails[key].productDisplayName }
              tireDetailUrl={ gBBDetails[key].tireDetailUrl }
              tireBadges={ gBBDetails[key].tireBadges } />
        )
      }
    </Column>
    <OtherInformation>
      <Delimiter><Link to={ searchByVehicleUrl } button>See All { matchedSkusCount } Matches</Link></Delimiter>
    </OtherInformation>
  </Wrapper>

RecommendedProducts.propTypes = {
  activeVehicle: PropTypes.shape({
    vehicleName: PropTypes.string
  }),
  gBBDetails: PropTypes.shape({
    bestValue: PropTypes.object,
    comeWithCar: PropTypes.object,
    lowestPrice: PropTypes.object,
    lowestPriceItem: PropTypes.any,
    oeItem: PropTypes.any,
    status: PropTypes.object,
    tireBadges: PropTypes.arrayOf(PropTypes.object),
    topBrand: PropTypes.object,
    topSellingItem: PropTypes.any
  }),
  matchedSkusCount: PropTypes.number,
  searchByVehicleUrl: PropTypes.string
}

export default RecommendedProducts

const Wrapper = styled.div`
  ${Mixin.responsive('margin', '0 auto 50px', '0 auto 40px')}
`
const Title = styled(Text)`
  ${Mixin.responsive('padding', '20px 10px 15px', '20px 16px 0')}
`
const Column = styled(Columns)`
  & [data-column] {
    ${Mixin.responsive('padding', '10px', '16px')}
  }
`

const OtherInformation = styled.div`
  text-align: center;
  ${Mixin.responsive('margin-top', '40px', '25px')}
`

const Delimiter = styled.div`
  font-size: 16px;
  color: ${Theme.colors.light_grey};

  ::before,
  ::after {
    display: inline-block;
    height: 2px;
    line-height: 10px;
    vertical-align: middle;
    background: ${Theme.colors.light_grey};
    content: '';
    ${Mixin.responsive('width', '402px', '50px')}
  }

  ::after {
    margin-left: 15px;
  }

  ::before {
    margin-right: 15px;
  }
`
